import opportunitiesEditMachine from './opportunitiesEditMachine';

export * from './opportunitiesEditMachine';
export default opportunitiesEditMachine;
